const SALESFORCE_ID_REGEX = /^(\w{15}|\w{18})$/;

// Salesforce encodes the object type in the first 3 chars of an ID.
// These prefixes are fixed for standard objects across all SF orgs.
const SF_PREFIX_ACCOUNT = '001';
const SF_PREFIX_OPPORTUNITY = '006';

export function isValidSalesforceId(val: string): boolean {
  return SALESFORCE_ID_REGEX.test(val);
}

export function isSalesforceAccountId(val: string): boolean {
  return isValidSalesforceId(val) && val.startsWith(SF_PREFIX_ACCOUNT);
}

export function isSalesforceOpportunityId(val: string): boolean {
  return isValidSalesforceId(val) && val.startsWith(SF_PREFIX_OPPORTUNITY);
}
